// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".how-it-works-vertical[data-v-4e915b84]{max-width:725px}@media(min-width:992px)and (max-width:99999px){.how-it-works-vertical__step[data-v-4e915b84]{width:50%}}.how-it-works-vertical__step-number[data-v-4e915b84]{border-radius:50%;height:40px;width:40px;padding-top:3px;text-align:center;display:inline-block}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
